module.exports = __webpack_public_path__ + "static/img/bg.95e5f4ad.jpg";